module.exports = __webpack_public_path__ + "/login_ui/img/bt-7c629ea7c1787858b712d9754748da96.svg";